import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Switch,
    Tabs,
    Tab,
    Typography,
    Button,
    IconButton,
} from "@mui/material";
import SearchBar from "../../components/SearchBar";
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}
const Blogs = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");

    // Dummy blog data
    const blogsData = [
        {
            thumbnail: "/static/images/placeholder.png",
            userimage: "/static/images/user_placeholder.png",
            username: "Alice",
            useremail: "Alice@exmaple.com",
            title: "How to Build a Web App",
            description: "A step-by-step guide to building a full-stack web application.",
            time: "10 min read",
            tags: "Web Development, React, JavaScript",
        },
        {
            thumbnail: "/static/images/placeholder.png",
            username: "Alice",
            useremail: "Alice@exmaple.com",
            userimage: "/static/images/user_placeholder.png",
            title: "Understanding CSS Grid",
            description: "Master the art of creating layouts with CSS Grid.",
            time: "7 min read",
            tags: "CSS, Web Design, Frontend",
        },
        {
            thumbnail: "/static/images/placeholder.png",
            username: "Alice",
            useremail: "Alice@exmaple.com",
            userimage: "/static/images/user_placeholder.png",
            title: "Introduction to Python for Beginners",
            description: "Learn the basics of Python programming language in this beginner-friendly tutorial.",
            time: "12 min read",
            tags: "Python, Programming, Backend",
        },
    ];

    const [valueTabs, setValueTabs] = React.useState(0);
    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabs(newValue);
    };
    return (
        <>
            <div className="main_title">
                <h1>Manage Journals</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Journals
                </p>
            </div>



            <Box className="custom_tabs1" sx={{ width: "100%" }}>
                <Tabs
                    value={valueTabs}
                    onChange={handleChangeTabs}
                    aria-label="basic tabs example"
                    className="custom_tabs_links tabs_img"
                >
                    <Tab label="Pending" {...a11yProps(0)} />
                    <Tab label="Published" {...a11yProps(1)} />
                    <Tab label="Rejected" {...a11yProps(2)} />
                </Tabs>
            </Box>
            <div className="cards">
                <CustomTabPanel value={valueTabs} index={0}>  <div className="table_header">
                    <Box className="left_s">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search by blog title or tag..."
                        />
                    </Box>
                    <div className="right_s">
                        <Button
                            className="btn btn_primary"
                            onClick={() => navigate("add")}
                        >
                            Add Journal
                        </Button>
                    </div>
                </div>

                <TableContainer className="table_container">
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Sr. No.</TableCell>

                                <TableCell>Thumbnail</TableCell>
                                <TableCell>Title</TableCell>
                                <TableCell>Description</TableCell>
                                <TableCell>Time</TableCell>
                                <TableCell>Tags</TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {blogsData.map((blog, index) => (
                                <TableRow key={index} hover>
                                    <TableCell>{index + 1}</TableCell>

                                    <TableCell>
                                        <div className="user_block">
                                            <figure>
                                                <img src={blog.thumbnail} alt={blog.title} />
                                            </figure>
                                        </div>
                                    </TableCell>
                                    <TableCell>{blog.title}</TableCell>
                                    <TableCell className="max_c2">{blog.description}</TableCell>
                                    <TableCell>{blog.time}</TableCell>
                                    <TableCell>{blog.tags}</TableCell>
                                    <TableCell>
                                        <div className="table_actions v2">
                                            <Box>
                                                <IconButton onClick={() => navigate("view")}>
                                                    <img src="/static/images/eye_icon.svg" alt="" />
                                                </IconButton>
                                            </Box>
                                            <Box>
                                                <IconButton>
                                                    <img src="/static/images/trash2_icon.svg" alt="" />
                                                </IconButton>
                                            </Box>
                                        </div>
                                    </TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer></CustomTabPanel>
                <CustomTabPanel value={valueTabs} index={1}>  <div className="table_header">
                    <Box className="left_s">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search by blog title or tag..."
                        />
                    </Box>
                    <div className="right_s">
                        <Button
                            className="btn btn_primary"
                            onClick={() => navigate("add")}
                        >
                            Add Journal
                        </Button>
                    </div>
                </div>

                <TableContainer className="table_container">
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Sr. No.</TableCell>

                                <TableCell>Thumbnail</TableCell>
                                <TableCell>Title</TableCell>
                                <TableCell>Description</TableCell>
                                <TableCell>Time</TableCell>
                                <TableCell>Tags</TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {blogsData.map((blog, index) => (
                                <TableRow key={index} hover>
                                    <TableCell>{index + 1}</TableCell>

                                    <TableCell>
                                        <div className="user_block">
                                            <figure>
                                                <img src={blog.thumbnail} alt={blog.title} />
                                            </figure>
                                        </div>
                                    </TableCell>
                                    <TableCell>{blog.title}</TableCell>
                                    <TableCell className="max_c2">{blog.description}</TableCell>
                                    <TableCell>{blog.time}</TableCell>
                                    <TableCell>{blog.tags}</TableCell>
                                    <TableCell>
                                        <div className="table_actions v2">
                                            <Box>
                                                <IconButton onClick={() => navigate("view")}>
                                                    <img src="/static/images/eye_icon.svg" alt="" />
                                                </IconButton>
                                            </Box>
                                            <Box>
                                                <IconButton>
                                                    <img src="/static/images/trash2_icon.svg" alt="" />
                                                </IconButton>
                                            </Box>
                                        </div>
                                    </TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer></CustomTabPanel>
                <CustomTabPanel value={valueTabs} index={2}>  <div className="table_header">
                    <Box className="left_s">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search by blog title or tag..."
                        />
                    </Box>
                    <div className="right_s">
                        <Button
                            className="btn btn_primary"
                            onClick={() => navigate("add")}
                        >
                            Add Journal
                        </Button>
                    </div>
                </div>

                <TableContainer className="table_container">
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Sr. No.</TableCell>

                                <TableCell>Thumbnail</TableCell>
                                <TableCell>Title</TableCell>
                                <TableCell>Description</TableCell>
                                <TableCell>Time</TableCell>
                                <TableCell>Tags</TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {blogsData.map((blog, index) => (
                                <TableRow key={index} hover>
                                    <TableCell>{index + 1}</TableCell>

                                    <TableCell>
                                        <div className="user_block">
                                            <figure>
                                                <img src={blog.thumbnail} alt={blog.title} />
                                            </figure>
                                        </div>
                                    </TableCell>
                                    <TableCell>{blog.title}</TableCell>
                                    <TableCell className="max_c2">{blog.description}</TableCell>
                                    <TableCell>{blog.time}</TableCell>
                                    <TableCell>{blog.tags}</TableCell>
                                    <TableCell>
                                        <div className="table_actions v2">
                                            <Box>
                                                <IconButton onClick={() => navigate("view")}>
                                                    <img src="/static/images/eye_icon.svg" alt="" />
                                                </IconButton>
                                            </Box>
                                            <Box>
                                                <IconButton>
                                                    <img src="/static/images/trash2_icon.svg" alt="" />
                                                </IconButton>
                                            </Box>
                                        </div>
                                    </TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer></CustomTabPanel>
              
            </div>


        </>
    );
};

export default Blogs;
